import { render, staticRenderFns } from "./V2DashboardWelcomeCard.vue?vue&type=template&id=269e04a0&scoped=true&"
import script from "./V2DashboardWelcomeCard.vue?vue&type=script&lang=js&"
export * from "./V2DashboardWelcomeCard.vue?vue&type=script&lang=js&"
import style0 from "./V2DashboardWelcomeCard.vue?vue&type=style&index=0&id=269e04a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269e04a0",
  null
  
)

export default component.exports